import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpGetClosedWorkflowItems = createApi(`GMPClosedWorkFlowItemsSlice`,"GET");

const GMPClosedWorkFlowItemsSlice = createSlice({
  name: 'GMPClosedWorkFlowItemsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpGetClosedWorkflowItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpGetClosedWorkflowItems.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpGetClosedWorkflowItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPClosedWorkFlowItemsSlice.reducer;